import { useCallback, useRef, useState } from "react"
import ReactCrop from "react-image-crop"
import 'react-image-crop/dist/ReactCrop.css';

import Modal from "../components/utils/Modal"
import TWInput from "../components/utils/TWInput/TWInput"
import TWButton from "../components/utils/TWButton/TWButton"
import AuthLayout from "../layouts/AuthLayout/AuthLayout"

import PhoriaLogo from '../assets/images/Phoria-Logo_YBBG.png'
import { useHistory } from "react-router-dom";

/**
 * @param {HTMLImageElement} image - Image File Object
 * @param {Object} crop - crop Object
 * @param {String} fileName - Name of the returned file in Promise
 */
function getCroppedImg(image, crop, fileName = 'avatar') {
	const canvas = document.createElement('canvas');
	const scaleX = image.naturalWidth / image.width;
	const scaleY = image.naturalHeight / image.height;
	canvas.width = crop.width;
	canvas.height = crop.height;
	const ctx = canvas.getContext('2d');

	console.log(ctx)

	ctx.drawImage(
		image,
		crop.x * scaleX,
		crop.y * scaleY,
		crop.width * scaleX,
		crop.height * scaleY,
		0,
		0,
		crop.width,
		crop.height,
	);

	// As Base64 string
	return canvas.toDataURL('image/jpeg');

	// As a blob
	// return new Promise((resolve, reject) => {
	// 	canvas.toBlob(blob => {
	// 		blob.name = fileName;
	// 		resolve(blob);
	// 	}, 'image/jpeg', 1);
	// });
}

const SignUp = () => {

	const history = useHistory()
	const [crop, setCrop] = useState({ aspect: 1 });
	const [cropComeplete, setCropComeplete] = useState(null);
	const avatarRef = useRef(null)
	const [state, setState] = useState({
		avatar: null,
		avatarCropped: null,
		avatarModal: false,
		showPassword: false,
	})

	const [user, setUser] = useState({
		username: {
			value: '',
			rules: 'required|min:3|max:16',
			name: 'username',
			hint: 'JohnnyBravo',
			label: 'Username*',
		},
		email: {
			value: '',
			type: 'email',
			name: 'email',
			rules: 'required|email',
			hint: 'johnnybravo@gmail.com',
			label: 'Email*'
		},
		password: {
			value: '',
			rules: 'required|min:6|max:16',
			type: 'password',
			name: 'password',
			label: 'Password*',
			hint: '***********'
		},
		confirmPassword: {
			value: '',
			type: 'password',
			name: 'confirmPassword',
			label: 'Confirm Password*',
			className: 'mb-4 md:mb-14',
			hint: '***********',
			errors: []
		},
		subscription: {
			value: '',
			hint: '$7.99',
			name: 'subscription',
			label: 'Subscription',
			helpText: 'This can be updated later in Settings'
		},
		bio: {
			value: '',
			name: 'bio',
			label: 'Bio',
			textarea: true,
			hint: 'Type your bio here',
			helpText: 'This can be updated later in Settings'
		}
	})

	// Methods
	const onLoad = useCallback(img => { avatarRef.current = img }, []);
	const onCropImage = () => {
		if (cropComeplete && cropComeplete.width === 0) return
		setState({
			...state,
			avatar: null,
			avatarModal: false,
			avatarCropped: getCroppedImg(
				avatarRef.current, cropComeplete
			)
		})
		setCropComeplete(null)
	}
	const handleClickUpload = () => {
		const input = document.createElement('input')
		input.type = 'file'
		input.accept = "image/x-png,image/gif,image/jpeg"
		input.addEventListener('close', () => {
			setState(s => ({ ...s, avatar: null }))
		})
		input.addEventListener('change', ev => {
			const file = ev.target.files[0]
			setState({
				...state,
				avatarModal: true,
				avatar: URL.createObjectURL(file),
			})
		})
		input.click()
	}

	return (
		<AuthLayout>
			<div className="signup">
				<div className="flex flex-col md:flex-row">
					<div className="w-44 mx-auto md:mr-16 mb-6 md:mb-0 md:mx-0">
						<img
							alt="Registration Avatar"
							src={state.avatarCropped || PhoriaLogo}
							className="rounded-xl mb-2 object-cover object-center w-44 h-44"
						/>
						<button
							onClick={handleClickUpload}
							className="font-bold flex items-center justify-center w-full"
						>
							<i className="material-icons mr-2">backup</i>
							<span className="mt-1">Upload Avatar</span>
						</button>
					</div>
					<form className='flex-1'>
						{Object.entries(user).map(([key, field]) => (
							<TWInput
								dark
								key={key}
								hint={field.hint}
								name={field.name}
								label={field.label}
								type={field.type}
								// errors="
								// 		field.errors && field.errors.length
								// 			? field.errors
								// 			: errors
								// 	"
								textarea={field.textarea || false}
								className={field.className || ' mb-1 md:mb-6'}
								helpText={field.helpText || ''}
								value={field.value}
								onChange={value => setUser({ ...user, [key]: { ...user[key], value } })}
								helpClass="text-center"
								inputClass="w-full md:w-96"
								labelClass='flex-1'
							>
								{/* <template v-slot:help-text>
										<p
											v-if="
													field.name === 'username' &&
													!errors.length
												"
										>
											This will be displayed as
											<span className="text-yellow-300">
												https://phoria.tv/{
													!!field.value
														? field.value
														: field.hint
												}
											</span>
										</p>
									</template> */}
							</TWInput>
						))}
						<TWButton
							size="sm"
							color="primary"
							className="px-10 block ml-auto"
							onClick={() => history.push('/home')}
						// disabled="invalid || cPassInvalid"
						>
							Sign Up
						</TWButton>
					</form>
				</div>
			</div>
			<Modal
				showClose
				backgroundClose
				contentClass='flex flex-col'
				value={state.avatarModal}
				onClose={() => setState({ ...state, avatarModal: false })}
			>
				<div className="bg-secondary rounded overflow-hidden flex-1 flex flex-col">
					<div className='p-4 md:p-5 flex-1 overflow-y-auto scrollbar-y'>
						<ReactCrop
							crop={crop}
							minWidth={128}
							maxWidth={512}
							className='rounded'
							src={state.avatar}
							onImageLoaded={onLoad}
							onChange={c => setCrop(c)}
							onComplete={c => setCropComeplete(c)}
						/>
					</div>
					<div className="flex-none bg-secondary2 shadow-xl p-4">
						<TWButton
							size="sm"
							color="primary"
							className="ml-auto block"
							onClick={onCropImage}
						>
							Crop Image
						</TWButton>
					</div>
				</div>
			</Modal>
		</AuthLayout>
	)
}

export default SignUp